import { useRouterState } from '@tanstack/react-router';

import { ShigoDashboardContext } from '../auth/dashboardDestination';
import { useShigoDashboardContext } from '../auth/useShigoDashboardContext';

export function useCommandPaletteAvailability(): boolean {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  return useShigoDashboardContext(pathname) === ShigoDashboardContext.Main;
}
